var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal-mask" }, [
    _c("div", { staticClass: "modal-wrapper" }, [
      _c("div", { staticClass: "modal_size att_size" }, [
        _c(
          "a",
          {
            staticClass: "ui_close",
            attrs: { href: "javascript:", type: "button" },
            on: {
              click: function($event) {
                return _vm.$emit("close")
              }
            }
          },
          [_c("span", { staticClass: "sr_only" }, [_vm._v("popup close")])]
        ),
        _vm._v(" "),
        _c("dl", { staticClass: "modal_content" }, [
          _c("dt", { staticClass: "ellipsis" }, [
            _c("i", [_vm._v(_vm._s(_vm.title))])
          ]),
          _vm._v(" "),
          _c(
            "dd",
            [
              _vm.attach.length > 0
                ? _c("innorix-download", {
                    attrs: {
                      uploadId: _vm.uploadId,
                      serviceType: _vm.serviceType,
                      attachList: _vm.attach,
                      seq: _vm.getKnowledgeId
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.attach.length > 0
                ? _c("dl", { staticClass: "attachment_link" }, [
                    _c("dt", [
                      _c(
                        "a",
                        {
                          staticClass: "txt_link",
                          attrs: { href: "javascript:" },
                          on: {
                            click: function($event) {
                              return _vm.toggleLink($event)
                            }
                          }
                        },
                        [_vm._v("Having trouble downloading?")]
                      )
                    ]),
                    _vm._v(" "),
                    _c("dd", [
                      _c(
                        "ul",
                        _vm._l(_vm.attach, function(file) {
                          return _c(
                            "li",
                            { key: file.ENC_ATTCH_FILE_SEQ + file.ENC_TOKEN },
                            [
                              _c(
                                "a",
                                {
                                  staticClass: "txt_link",
                                  attrs: { href: "javascript:" },
                                  on: {
                                    click: function($event) {
                                      return _vm.getDownloadUrl(
                                        file.ENC_ATTCH_FILE_SEQ,
                                        file.ENC_TOKEN
                                      )
                                    }
                                  }
                                },
                                [
                                  _c("span", { staticClass: "ico_attach" }),
                                  _vm._v(
                                    " " +
                                      _vm._s(file.FILE_NM) +
                                      "\n                                    "
                                  )
                                ]
                              )
                            ]
                          )
                        }),
                        0
                      )
                    ])
                  ])
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c("dd", { staticClass: "scroll_btm" }, [
            _c("div", { staticClass: "btn_wrap topLine" }, [
              _c("div", { staticClass: "btn_right" }, [
                _c(
                  "a",
                  {
                    staticClass: "btn_white",
                    attrs: { href: "javascript:" },
                    on: {
                      click: function($event) {
                        return _vm.$emit("close")
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.CLOSE")))]
                )
              ])
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-14778752", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14778752","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/skpComponents/view/basis/knowledge/popup/KnowledgeAttachFilePopup.vue
// module id = 2+px
// module chunks = 0